import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { usePublicConfig } from "@/api/queries/config";
import { usePageMeta } from "@/hooks/use-page-meta";
import { loadLegalContent } from "@/lib/legal-content";

export const Route = createFileRoute("/_public/impressum")({
	component: ImpressumPage,
});

function ImpressumPage() {
	const { data: config } = usePublicConfig();
	const [html, setHtml] = useState("");

	usePageMeta({
		title: config?.seo.titles.impressum,
		description: config?.seo.descriptions.impressum || undefined,
	});

	useEffect(() => {
		loadLegalContent("impressum").then(setHtml);
	}, []);

	return (
		<div className="max-w-3xl mx-auto">
			<div
				className="prose text-text-secondary [&_h1]:text-text [&_h2]:text-text"
				dangerouslySetInnerHTML={{ __html: html }}
			/>
		</div>
	);
}
